export default __webpack_public_path__ + "images/0xa7d7079b0fead91f3e65f86e8915cb59c1a4c664.png";